import { Typography, Tooltip, Box, styled } from '@mui/material';
import { CustomWarningOutlinedIcon } from '../../../scan/components/DataGridScanStatusField/styles';

export const ScanQualityWarning = () => {
  return (
    <Tooltip
      title='Low-quality 3D model detected. AI predicted Cobb angle estimate may be inaccurate - please review and rescan if needed'
      arrow
      placement='left'
    >
      <ScanQualityContainer>
        <CustomWarningOutlinedIcon
          style={{ fontSize: '1.25rem', marginRight: '0.1vw' }}
        />
        <Typography fontWeight='bold'>Quality Warning</Typography>
      </ScanQualityContainer>
    </Tooltip>
  );
};

const ScanQualityContainer = styled(Box)`
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: white;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;
